import React, { useState } from "react";
import InputDate from "../shared components/DateInput/InputDate";
import OutsideClickHandler from "react-outside-click-handler";

type propType = {
  state?: any;
  apiCall?: (val: any) => void;
  setState?: (val: any) => void;
  fieldName?: string;
  label?: string;
  isFutureDateRequired?: boolean;
};

const PassSingleDate: React.FC<propType> = ({
  state,
  apiCall,
  setState,
  fieldName,
  label,
  isFutureDateRequired,
}) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState("");

  const fn = {
    setFilterState: () => {
      setIsFilterOpen(!isFilterOpen);
    },
    addParam: () => {
      if (startDate != "") {
        setState?.({
          ...state,
          [fieldName ?? ""]: `${startDate}`,
        });
        apiCall?.({
          ...state,
          page: 1,
          [fieldName ?? ""]: `${startDate}`,
        });
        fn.setFilterState();
      }
    },
    removeParam: () => {
      setStartDate("");
      delete state[fieldName ?? ""];
      apiCall?.({ ...state });
      fn.setFilterState();
    },
  };

  return (
    <>
      <OutsideClickHandler onOutsideClick={() => setIsFilterOpen(false)}>
        <div className="position-relative">
          <div
            className="filter_section_wrapper"
            onClick={fn.setFilterState}
            style={{
              backgroundColor: isFilterOpen ? "#fff" : "var(--bg_color2)",
              border: isFilterOpen ? "1px solid var(--border_color4)" : "none",
            }}
          >
            <img
              src={`/Assets/Svg/${
                isFilterOpen ? "filterClose.svg" : "calendarFilter.svg"
              }`}
              alt="filter"
            />
          </div>

          {isFilterOpen && (
            <div className="filter_option_wrapper">
              <p className="mb-0 font12x500 px-2 pt-2">{label}:</p>
              <div className="p-2">
                <div className="w-100">
                  <InputDate
                    state={startDate}
                    setState={(e) => setStartDate(e)}
                    isFutureDateRequired={isFutureDateRequired}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end p-2 gap-2">
                <div>
                  <button
                    className="btn font12x500 shadow-none btn_with_color"
                    onClick={fn.addParam}
                  >
                    Apply
                  </button>
                </div>
                <div>
                  <button
                    className="btn font12x500 shadow-none btn_without_color"
                    disabled={startDate === "" ? true : false}
                    onClick={fn.removeParam}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </OutsideClickHandler>
    </>
  );
};

export default PassSingleDate;
